import React from 'react';

import BenefitsBanner from 'components/Banner/BenefitsBanner/BenefitsBanner';
import CardBanner from 'components/Banner/CardBanner/CardBanner';
import LandingSkinnyBanner from 'components/Banner/SkinnyBanner/Landing/LandingSkinnyBanner';
import SkinnySelfcareA from 'components/Banner/SkinnyBanner/Selfcare';
import SupportBanner from 'components/Banner/SupportBanner/SupportBanner';
import SupportBannerGroup from 'components/Banner/SupportBanner/SupportBannerGroup/SupportBannerGroup';
import HubBanner from 'components/Banner/HubBanner/HubBanner';
import { HeroWrapper, HeroA, HeroA4, HeroB, HeroC, HeroDWrapper, HeroD, HeroE, HeroMapSection } from 'components/Banner/HeroBanner';
import CountryMap from 'components/Map/CountryMap/CountryMap';
import TestimonialBanner from 'components/Banner/OthersBanner/TestimonialsBanner/TestimonialsBanner';
import CarouselBanner from 'components/Banner/OthersBanner/CarouselBanner/CarouselBanner';
import { ArticlesBannerA, ArticlesBannerB } from 'components/Banner/OthersBanner/ArticlesBanner';
import NewsBanner from 'components/Banner/OthersBanner/NewsBanner/NewsBanner';
import AdvantagesBanner from 'components/Banner/OthersBanner/AdvantagesBanner/AdvantagesBanner';
import MediaBanner from 'components/Banner/OthersBanner/MediaBanner/MediaBanner';

import {
  benefitItemsVer1,
  benefitItemsVer2,
  cardsTypeA,
  cardsTypeB,
  LandingSkinnyTypeA,
  LandingSkinnyTypeB,
  hubBannerItems,
  testimonialsData,
  carouselSlidesA,
  carouselSlidesB,
  articlesArray,
  articlesArrayB,
  getMediaBannerData
} from './bannersData';

/* eslint-disable react/prop-types */
export const benefitsBannerLayout = ({ version = 1, __key }) => {

  const items = version === 1 ? benefitItemsVer1 : benefitItemsVer2;

  return (
    <BenefitsBanner
      className="main-content"
      highlighted="Fusce vehicula dolor arcu, sit sec."
      items={items}
      key={__key}
      subtitle="Nam porttitor blandit accumsan. Ut vel dictum sem, a pretium dui. In malesuada."
      title="Curabitur lobortis id is bibendum."
    />
  );
};

export const cardsBannerLayout = ({ version = 1 }) => {

  const versionProps = version === 1 ? cardsTypeA : cardsTypeB;
  
  return (
    <CardBanner
      title="Lorem ipsum"
      tabKey="key"
      className="main-content"
      {...versionProps}
    />
  );
};

export const landingSkinnyBannerLayout = ({ version = 1 }) => {

  const versionProps = version === 1 ? LandingSkinnyTypeA : LandingSkinnyTypeB;

  return (
    <LandingSkinnyBanner
      className="main-content"
      {...versionProps}
    />
  );
};

export const selfcareSkinnyBannerLayout = () => (
  <SkinnySelfcareA
    className="main-content"
    icon="apps"
    highlighted="Lorem ipsum dolor eiusmod sitsd."
    title="Consectetur adipiscing elits."
    description="Excepteur sint occaecat cupidata non proident sunt in culpa officia."
    button="action"
  />
);

export const supportBannerLayout = () => (
  <SupportBanner
    className="main-content"
    title="We’re here to help your"
    highlighted="business succeed."
  >
    <SupportBannerGroup
      title="Get in touch."
      description="Reach us if you need further information or have any questions."
      link="contact us"
      onClick={(e) => e.preventDefault()}
    />
    <SupportBannerGroup
      title="Need help?"
      description="We put together a list of answers for frequently asked questions."
      link="Faqs"
      onClick={(e) => e.preventDefault()}
    />
    <SupportBannerGroup
      title="Our Newsletter"
      description="Subscribe our newsletter to be the first to hear what’s happening."
      placeholder="Input text"
      onClick={() => console.log('input was clicked')}
    />
  </SupportBanner>
);

export const hubBannerLayout = () => (
  <HubBanner
    highlighted="Lorem ipsum at"
    title="dolor sit amet"
    description="Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    items={hubBannerItems}
  />
);

export const heroBannerTypeALayout = ({ version = 1 }) => {
  const heroTitle = 'Lorem ipsum dolor sit amet, conctetur.';
  const description = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla, sit amet diam. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla.';

  const version1 = (
    <HeroWrapper>
      <HeroA
        label="Airtel Business Internet"
        title={heroTitle}
        description={description}
        link="only text"
        onClick={() => console.log('link clicked')}
        v2={version === 2}
      />
      <HeroA
        label="Airtel Business Internet"
        title={heroTitle}
        description={description}
        link="only text"
        onClick={() => console.log('link clicked')}
        right
        v2={version === 2}
      />
    </HeroWrapper>
  );

  const version3 = (
    <HeroWrapper>
      <HeroA
        label="Airtel Business Internet"
        title={heroTitle}
        description={description}
        link="only text"
        onClick={() => console.log('link clicked')}
      />
      <HeroMapSection
        link={{ text: 'ONLY TEXT 14PX', onClick: () => console.log('provide callback')}}
        primaryBtn={{ text: 'primary', onClick: () => console.log('provide callback')}}
        secondaryBtn={{ text: 'secondary', onClick: () => console.log('provide callback')}}
      >
        <CountryMap
          center={{ lat: 52.076604, lng: -0.522302 }}
          zoom={5}
        />
      </HeroMapSection>
    </HeroWrapper> 
  );

  const version4 = (
    <HeroWrapper>
      <HeroA4
        colorScheme="lb01"
        label="Lorem ipsum dolor sit amet"
        title="Lorem ipsum dolor sit amet, dolor sit."
      />
      <HeroA4
        colorScheme="lb01"
        label="Lorem ipsum dolor sit amet"
        title="Lorem ipsum dolor sit amet, dolor sit."
      />
    </HeroWrapper>
  );

  return version === 1 || version === 2
    ? version1
    : version === 3
      ? version3
      : version4;
};

export const heroBannerTypeBLayout = ({ version = 1 }) => {
  const heroTitle = 'Lorem ipsum dolor sit amet, conctetur.';
  const description = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla, sit amet diam';

  const version1 = (
    <HeroWrapper>
      <HeroA
        label="Airtel Business Internet"
        title={heroTitle}
        description={description}
        link="only text"
        onClick={() => console.log('link clicked')}
      />
      <HeroB
        colorScheme="lb01"
        description={description}
        button={{ type: 'primary', innerText: 'button' }}
        onClick={() => console.log('button clicked')}
      />
    </HeroWrapper>
  );

  const version2 = (
    <HeroWrapper>
      <HeroA4
        colorScheme="lb01"
        label="Lorem ipsum dolor sit amet"
        title="Lorem ipsum dolor sit amet, dolor sit."
      />
      <HeroB
        colorScheme="lb01"
        description={description}
        button={{ type: 'primary', innerText: 'button' }}
        onClick={() => console.log('button clicked')}
        v2={version === 2}
      />
    </HeroWrapper>
  );

  return version === 1 ? version1 : version2;
};

export const heroBannerTypeCLayout = () => {
  const heroTitle = 'Lorem ipsum dolor sit amet, conctetur.';
  const description = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla, sit amet diam. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla.';

  return (
    <HeroWrapper youtubeVideoId="kAznA6cFErw">
      <HeroA
        label="Airtel Business Internet"
        title={heroTitle}
        description={description}
        link="only text"
        onClick={() => console.log('link clicked')}
      /> 
      <HeroC />
    </HeroWrapper>
  );
};

export const heroBannerTypeDLayout = () => {
  const description = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla, sit amet diam. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla.';

  return (
    <HeroWrapper>
      <HeroA
        label="Airtel Business Internet"
        title="Lorem ipsum dolor sit amet"
        description={description}
        link="only text"
        onClick={() => console.log('link clicked')}
      /> 
      <HeroDWrapper>
        <HeroD
          title="Lorem ipsum dolor sit amet"
          description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla."
          onClick={() => console.log('click')}
          link="only text"
        />
        <HeroD
          title="Lorem ipsum dolor sit amet"
          description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla."
          onClick={() => console.log('click')}
          link="only text"
          colorScheme="lb02"
        />
      </HeroDWrapper>
    </HeroWrapper>
  );
};

export const heroBannerTypeELayout = () => (
  <HeroWrapper colorScheme="pb01" thumbnail="http://tremendouswallpapers.com/wp-content/uploads/2014/12/new-york-city-1.jpeg">
    <HeroA4
      label="Lorem ipsum dolor sit amet"
      title="Lorem ipsum dolor sit amet, dolor sit."
    />
    <HeroB
      description={'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a imperdiet nulla, sit amet diam.'}
      button={{ type: 'primary', innerText: 'button' }}
      onClick={() => console.log('button clicked')}
      v2
    />
    <HeroE description="Description up to three lines of the text." sections={[{ icon: { icon: 'hot-deals', type: '20' }, description: 'Description up to three lines of the text.' }, { icon: { icon: 'hot-deals', type: '20' }, description: 'Description up to three lines of the text.' }, { icon: { icon: 'hot-deals', type: '20' }, description: 'Description up to three lines of the text.' }, { icon: { icon: 'hot-deals', type: '20' }, description: 'Description up to three lines of the text.' }, { icon: { icon: 'hot-deals', type: '20' }, description: 'Description up to three lines of the text.' }]} />
  </HeroWrapper>
);

export const testimonialsBannerLayout = () => <TestimonialBanner testimonials={testimonialsData} autoplay className="main-content" />;

export const carouselBannerLayout = ({ version = 1 }) => (
  <CarouselBanner
    left={version === 2}
    slides={version === 1 ? carouselSlidesA : carouselSlidesB}
    autoplay
    className="main-content"
  />
);

export const articlesBannerLayout = ({ version = 1 }) => {
  const articlesBannerA = (
    <ArticlesBannerA
      label="Knowledge Hub"
      pageLink="go to page"
      pageCallback={() => console.log('go to page')}
      highlighted="We are committed to the highest standards of corporate governance."
      description="This reflects in our ethical business decisions and transparent conduct."
      articles={articlesArray}
    />
  );

  const articlesBannerB = (
    <ArticlesBannerB
      primaryKey="section"
      secondaryKey="year"
      primaryLabel="content type"
      secondaryLabel="year"
      articles={articlesArrayB}
    />
  );

  return version === 1 ? articlesBannerA : articlesBannerB;
};

export const advantagesBannerLayout = () => {
  const offers = [
    {
      title: 'Rates and Usage Analytics',
      items: ['Track Traffic & Rates', 'Track Traffic & Rates', 'Track Traffic & Rates']
    },
    {
      title: 'Rates and Usage Analytics',
      items: ['Track Traffic & Rates', 'Track Traffic & Rates', 'Track Traffic & Rates']
    },
    {
      title: 'Rates and Usage Analytics',
      items: ['Track Traffic & Rates', 'Track Traffic & Rates', 'Track Traffic & Rates']
    },
    {
      title: 'Rates and Usage Analytics',
      items: ['Track Traffic & Rates', 'Track Traffic & Rates', 'Track Traffic & Rates']
    }
  ];

  const statistics = [
    {
      label: 'Countries',
      info: '17',
      illustration: {
        name: 'find-rates',
        size: '120'
      }
    },
    {
      label: 'Partnerships',
      info: '1200+',
      illustration: {
        name: 'itfs',
        size: '120'
      }
    },
    {
      label: 'support',
      info: '24/7',
      illustration: {
        name: 'internet',
        size: '120'
      }
    },
  ];

  return (
    <AdvantagesBanner
      offers={offers}
      statistics={statistics}
      backgroundImage="http://tremendouswallpapers.com/wp-content/uploads/2014/12/new-york-city-1.jpeg"
    />
  );
};

export const newsBannerLayout = () => {
  const newsArray = [
    {
      titleHighlight: 'Bharti Airtel enters into an exclusive agreement with Orascom to acquire Middle East North Africa',
      title: 'Submarine Cable System.',
      date: 'May 12, 2017 under',
      dateHighlight: 'Enterprise',
      link: 'read more',
      onClick: () => console.log('link clicked')
    },
    {
      title: 'Airtel launches ‘India with Airtel’ – end-to-end connectivity solutions for companies looking to set up businesses in India.',
      date: 'May 12, 2017 under',
      dateHighlight: 'Enterprise',
      link: 'read more',
      onClick: () => console.log('link clicked')
    },
    {
      title: ' – end-to-end connectivity solutions for companies looking to set up businesses in India.',
      titleHighlight: 'Airtel launches',
      date: 'May 12, 2017 under',
      dateHighlight: 'Enterprise',
      link: 'read more',
      onClick: () => console.log('link clicked')
    },
    {
      title: 'Airtel launches ‘India with Airtel’ – end-to-end connectivity solutions for companies looking to set up businesses in India.',
      date: 'May 12, 2017 under',
      dateHighlight: 'Enterprise',
      link: 'read more',
      onClick: () => console.log('link clicked')
    }
  ];

  return (
    <NewsBanner
      label="Latest News"
      pageLink="View All"
      pageCallback={() => console.log('go to page')}
      news={newsArray}
    />
  );
};

export const mediaBannerLayout = ({ version = 1 }) => <MediaBanner slides={getMediaBannerData(version)} />;

/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/components/Banner/constants/bannersLayouts.js